import { Checkbox } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

export const StyledCheckbox = styled(Checkbox)(
  ({ theme: { admanColors, colors } }) => css`
    & + .TrekCheckbox-root {
      border: 1px solid ${admanColors!.gray.light.bg3[1]};
    }

    &:checked + .TrekCheckbox-root {
      background: ${admanColors!.blue.dark.bg1[0]};
      border: 1px solid ${admanColors!.blue.dark.bg1[0]};
    }

    &:checked {
      &:hover + .TrekCheckbox-root {
        background: ${admanColors!.blue.dark.bg2[0]};
        border: 1px solid ${admanColors!.blue.dark.bg2[0]};
      }

      &:hover + .TrekCheckbox-root::after,
      &:disabled + .TrekCheckbox-root::after {
        content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yMDY2IDYuMDQyMzlDMjAuNTk3NCA2LjQzMjYzIDIwLjU5NzkgNy4wNjU4IDIwLjIwNzYgNy40NTY2TDkuNzIyNjcgMTcuOTU2NkM5LjUyOTI2IDE4LjE1MDMgOS4yNjQ5MSAxOC4yNTYyIDguOTkxMjcgMTguMjQ5N0M4LjcxNzYzIDE4LjI0MzIgOC40NTg2MiAxOC4xMjQ4IDguMjc0NjQgMTcuOTIyMUwzLjc1OTU5IDEyLjk0ODVDMy4zODgzNyAxMi41Mzk1IDMuNDE4OTQgMTEuOTA3MSAzLjgyNzg2IDExLjUzNTlDNC4yMzY3OSAxMS4xNjQ3IDQuODY5MjEgMTEuMTk1MiA1LjI0MDQzIDExLjYwNDJMOS4wNDk1NiAxNS44MDAyTDE4Ljc5MjQgNi4wNDM0QzE5LjE4MjcgNS42NTI2IDE5LjgxNTggNS42NTIxNCAyMC4yMDY2IDYuMDQyMzlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=);
        mask: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yMDY2IDYuMDQyMzlDMjAuNTk3NCA2LjQzMjYzIDIwLjU5NzkgNy4wNjU4IDIwLjIwNzYgNy40NTY2TDkuNzIyNjcgMTcuOTU2NkM5LjUyOTI2IDE4LjE1MDMgOS4yNjQ5MSAxOC4yNTYyIDguOTkxMjcgMTguMjQ5N0M4LjcxNzYzIDE4LjI0MzIgOC40NTg2MiAxOC4xMjQ4IDguMjc0NjQgMTcuOTIyMUwzLjc1OTU5IDEyLjk0ODVDMy4zODgzNyAxMi41Mzk1IDMuNDE4OTQgMTEuOTA3MSAzLjgyNzg2IDExLjUzNTlDNC4yMzY3OSAxMS4xNjQ3IDQuODY5MjEgMTEuMTk1MiA1LjI0MDQzIDExLjYwNDJMOS4wNDk1NiAxNS44MDAyTDE4Ljc5MjQgNi4wNDM0QzE5LjE4MjcgNS42NTI2IDE5LjgxNTggNS42NTIxNCAyMC4yMDY2IDYuMDQyMzlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=)
          no-repeat center;
        mask: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yMDY2IDYuMDQyMzlDMjAuNTk3NCA2LjQzMjYzIDIwLjU5NzkgNy4wNjU4IDIwLjIwNzYgNy40NTY2TDkuNzIyNjcgMTcuOTU2NkM5LjUyOTI2IDE4LjE1MDMgOS4yNjQ5MSAxOC4yNTYyIDguOTkxMjcgMTguMjQ5N0M4LjcxNzYzIDE4LjI0MzIgOC40NTg2MiAxOC4xMjQ4IDguMjc0NjQgMTcuOTIyMUwzLjc1OTU5IDEyLjk0ODVDMy4zODgzNyAxMi41Mzk1IDMuNDE4OTQgMTEuOTA3MSAzLjgyNzg2IDExLjUzNTlDNC4yMzY3OSAxMS4xNjQ3IDQuODY5MjEgMTEuMTk1MiA1LjI0MDQzIDExLjYwNDJMOS4wNDk1NiAxNS44MDAyTDE4Ljc5MjQgNi4wNDM0QzE5LjE4MjcgNS42NTI2IDE5LjgxNTggNS42NTIxNCAyMC4yMDY2IDYuMDQyMzlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=)
          no-repeat center / contain;
        background-color: ${colors!.colorWhite};
        height: 16px;
        left: -1px;
        position: absolute;
        top: -1px;
        width: 16px;
      }

      &:disabled + .TrekCheckbox-root {
        background: ${admanColors!.blue.dark.bg1[0]};
        border: 1px solid ${admanColors!.blue.dark.bg1[0]};
      }
    }

    &:hover + .TrekCheckbox-root {
      border: 1px solid ${admanColors!.gray.light.fg1[2]};
      cursor: pointer;
    }

    &:hover + .TrekCheckbox-root.TrekCheckbox-disabled {
      cursor: not-allowed;
    }

    &:focus + .TrekCheckbox-root {
      box-shadow: 0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.light.bg1[1]};
      border: 1px solid ${admanColors!.blue.dark.bg2[1]};
    }

    &:active + .TrekCheckbox-root {
      background: ${admanColors!.blue.dark.bg2[1]};
      border: 1px solid ${admanColors!.blue.dark.bg2[1]};
    }

    &:hover + .TrekCheckbox-root::after,
    &:disabled + .TrekCheckbox-root::after {
      background-color: ${colors!.colorWhite};
      background: ${colors!.colorWhite};
      border: 1px solid ${admanColors!.gray.light.bg3[2]};
      height: 16px;
      left: -1px;
      position: absolute;
      top: -1px;
      width: 16px;
    }

    &:disabled + .TrekCheckbox-root {
      background: ${colors!.colorWhite};
      border: 1px solid ${admanColors!.gray.light.bg3[2]};
    }
  `
);
